import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { TxmManagementComponent} from "./txm-management.component";

const routes: Routes = [
  {
    path:'',
    redirectTo: 'txmmanagement',
    pathMatch: 'full',
  },
  {
    path:'txmmanagement',
    component: TxmManagementComponent,
    canDeactivate:[DeactivateGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TxmManagementRoutingModule { }
